<template>
    <div id="main">
        <div v-if="!isToday" class="topic">Countdown to my birthday</div>
        <div v-if="!isToday" style="display:flex;justify-content:space-between;width:100%">
            <div class="font-weight-bold">{{days || 0}} <br> <span class="detail">{{$t('days')}}</span></div>
            <div class="font-weight-bold">{{hours || 0}} <br> <span class="detail">{{$t('hours')}}</span></div>
            <div class="font-weight-bold">{{minutes || 0}} <br> <span class="detail">{{$t('minutes')}}</span></div>
            <div class="font-weight-bold">{{seconds || 0}} <br> <span class="detail">{{$t('seconds')}}</span></div>
        </div>
        <div v-else class="text-center">
            Today Is My Birthday &#x1F382;
        </div>
    </div>
</template>
<script>
var moment = require('moment');
export default {
    data : ()=>{
        return {
            days:"",
            hours:"",
            minutes:"",
            seconds:"",
            isToday:false
        }
    },
    created : function(){
        var birthdate = moment(this.$store.getters.birthdate,"DD/MM/YYYY")
        var now = moment()
        var thisYear = now.get("year");
        var thisYearBirthdate = moment(birthdate.get("date")+"/"+((birthdate.get("month")+1)+"").padStart(2,"0")+"/"+thisYear,"DD/MM/YYYY")
        var nextBirthDate = moment(thisYearBirthdate)
        if(nextBirthDate.diff(now,"days") < 0) nextBirthDate.add(1,"years")
        if(nextBirthDate.diff(now,"days") == 0) this.isToday = true
        var diff = moment.duration(nextBirthDate.diff(now))
        if(!this.isToday){
            setInterval(function(){
                diff = moment.duration(diff.asMilliseconds()-1000,'milliseconds')
                if(diff>0){
                    this.days = parseInt(diff.asDays()+"");
                    this.hours = diff.hours().toString().length==1?"0"+diff.hours():diff.hours();
                    this.minutes = diff.minutes().toString().length==1?"0"+diff.minutes():diff.minutes();
                    this.seconds = diff.seconds().toString().length==1?"0"+diff.seconds():diff.seconds();
                }else{
                    this.isToday = true
                }
            }.bind(this),1000)
        }
    }
}
</script>
<style scoped>
    #main{
        padding: 2rem  3rem 
    }

    .topic{
        margin:1rem 0rem;
        text-shadow: 2px 0.5px rgba(91, 121, 119, 0.4);
        font-weight: bold;
    }

    .detail{
        text-shadow: 2px 0.5px rgba(91, 121, 119, 0.4);
        font-weight: normal;
    }
</style>


// WEBPACK FOOTER //
// src/components/project/countdown.vue